import './form.css';
import { useState, useRef, useEffect } from 'react';

import { useNavigate, useSearchParams } from 'react-router-dom';
import SpacerBars from '../../components/spacerBars/spaceBar';
import Button from '../../components/button/button';
import DropDownArrow from '../../assets/icons/dropDownArrow/dropDownArrow'

const currentProtocol = window.location.protocol;
const currentHost = window.location.host.replace(/^www\./, '');



export default function Form({ onSignInSuccess, submitType, typeOfButton, formTag, titleTag, emailTag, nameTag, subjectTag, messageTag, passwordTag, confirmPassordTag, industryTemplate}) {
    
    const navigate = useNavigate();

    // useState variables for form
    const [errorMsg, setErrorMsg] = useState('');
    
    // useState variables for the entires on the form
    const [company_name, set_company_name] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [subject, setSubject] = useState('');
    const [message, setMessage] = useState('');

    //testing button
    const testButtonRef = useRef(null);

    const testClick = () => {
       alert("testing the click");
    }

    // 2. Attach the native event listener on mount
  useEffect(() => {
    const buttonElement = testButtonRef.current;
    
    if (buttonElement) {
      buttonElement.addEventListener('click', testClick);
    }

    // Clean up the listener if the component unmounts
    return () => {
      if (buttonElement) {
        buttonElement.removeEventListener('click', testClick);
      }
    };
  }, []); // Empty dependency array ensures this runs once

  // login handle
    const handleLogin = async (e) => {
    e.preventDefault();
    setErrorMsg('');

    try {
      const response = await fetch('/express/api/login/', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify({ email, password }),
        });


      const data = await response.json();
      console.log(data);

      if (response.ok) {
        // 1. Notify parent state if needed
        if (onSignInSuccess) {
          onSignInSuccess(true);
        }
        
       //window.location.href = `https://www.expensible/dashboard.cloud`;
       window.location.href = `${currentProtocol}//dashboard.${currentHost}`;
      } else {
        setErrorMsg(data.error || 'Invalid email or password');
        alert('Email or password not found, please try again')
        if (onSignInSuccess) {
          onSignInSuccess(false);
        }
      }
    } catch (err) {
      console.error('Login request error:', err);
      setErrorMsg('Could not connect to authentication server.');
      if (onSignInSuccess) {
        onSignInSuccess(false);
      }
    }
  };

  // the handle for the contact page submition
    const handleContact  = () => {
        alert('Message sent!');
    }

  // handleSignUp

  const handleSignUp = async (e) => {
        e.preventDefault();
        setErrorMsg('');
        //setLoading(true);

        try {
            const response = await fetch('/express/api/signUp/', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ company_name, email, password,  }),
            });

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Failed to sign up.');
            }

            console.log('Registration success:', data);
            alert('Account created successfully!');
            
            
            navigate('/sign_in');

        } catch (err) {
            setErrorMsg(err.message);
        } finally {
            //setLoading(false);
        }
  }

  // map the submitType to the function

    const getSubmitHandler = (submitType) => {
    if (submitType === 'handleLogin') {
        return handleLogin;
    } 
    if (submitType === 'handleContact') {
        return handleContact;
    }
    if (submitType === 'handleSignUp') {
        return handleSignUp;
    }
    
    alert(`${submitType} is the input`);
    return null;
    };
    
    return (
        <div>
            <div>
                <div className="form-title">
                    <h1>{titleTag}</h1>
                    <SpacerBars width="24rem" color="var(--background-color)" center="auto"/>
                </div>

                <form onSubmit={(e) => getSubmitHandler(submitType)(e)}>  

                    {nameTag && 
                        <div>
                            <input
                            type="text"
                            value={company_name}
                            onChange={(e) => set_company_name(e.target.value)}
                            required
                            placeholder="enter company name..."
                            />
                        </div>
                    }

                    {emailTag && 
                        <div>
                            <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            placeholder="enter your email..."
                            />
                        </div>
                    }

                    {passwordTag && 
                        <div>
                            <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            placeholder="enter your password..."
                            />
                        </div>
                    }

                    {confirmPassordTag && 
                        <div>
                            <input
                            type="password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            placeholder="enter your password..."
                            />
                        </div>
                    }

                    {subjectTag && 
                        <div>
                            <input
                            type="text"
                            value={subject}
                            onChange={(e) => setSubject(e.target.value)}
                            required
                            placeholder="enter the subject..."
                            />
                        </div>
                    }

                    {messageTag && 
                        <div>
                            <textarea
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            required
                            placeholder="type your message here..."
                            rows={7}
                            />
                        </div>
                    }

                    {industryTemplate && 
                        <div className="industry-template-container">
                          <select id="industry-template" name="industry-template" className="industry-template">
                            <option value="volvo">Volvo</option>
                            <option value="saab">Saab</option>
                            <option value="fiat">Fiat</option>
                            <option value="audi" selected>select an industry template</option>
                          </select>
                          <DropDownArrow/>
                        </div>
                    }

                    <div className="forms-button">
                        <Button buttonName="Submit!" buttonType={typeOfButton}/>
                    </div>

                </form>
                
            </div>
        </div>
    )
};